import { render, staticRenderFns } from "./HousingModalQuotaCharge.vue?vue&type=template&id=c1994810&scoped=true&"
import script from "./HousingModalQuotaCharge.vue?vue&type=script&lang=js&"
export * from "./HousingModalQuotaCharge.vue?vue&type=script&lang=js&"
import style0 from "./HousingModalQuotaCharge.vue?vue&type=style&index=0&id=c1994810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1994810",
  null
  
)

export default component.exports